// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-date[data-v-ee2d464c] {\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  background-color: #fff;\n  padding: 10px;\n  margin-bottom: 0.3rem;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.card-group[data-v-ee2d464c] > *:nth-last-child(1) {\n  margin-bottom: 3rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
